module.exports = __webpack_public_path__ + "static/media/404-bg-ipad.0e761c39.jpg";